import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

// 获取localStorage中的语言设置
const language = window.language || 'en';

i18n.use(Backend).use(initReactI18next).init({
  lng: language,
  nsSeparator: false, // key的空间分割，不分割
  keySeparator: false,// key的分割字符 不分割
  fallbackLng: 'en', // resources中匹配不到时的语言
  interpolation: {
    escapeValue: false,
  },
  backend: {
    loadPath: '/Language/{{lng}}.json', // 按需加载
  },
  react: {
    useSuspense: true,
  },
});

const Words = function (key, v1, v2, v3, v4) {
  // 不传入变量
  return i18n.t(key, { v1, v2, v3, v4 }); // 调取语言包，翻译
}

export default Words;